import ScrollToTop from "../hooks/ScrollToTop";
import UserLayout from "./UserLayout";
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from "../pages/Home/Home"
import LandingPage from "../pages/LandingPage/Home";
import Thankyou from "../pages/thankyou/Thankyou";
import Contact from "../pages/Contact/Contact";
import Blog from "../pages/Blog/Blog";
import BlogDetail from "../pages/BlogDetail/BlogDetail";
import Error from "../pages/404/Error";
import About from "../pages/About/About";
import ProjectListing from "../pages/ProjectListing/ProjectListing";
import ProjectDetail from "../pages/ProjectDetail/ProjectDetail";
import Services from "../pages/Services/Services";
import ServiceDetail from "../pages/ServiceDetail/ServiceDetail";
import ModularWork from "../pages/ModularWork/ServiceDetail";
import Millwork from "../pages/Millwork/ServiceDetail";
import TurnkeySolution from "../pages/TurnkeySolution/ServiceDetail";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TermCondition from "../pages/TermCondition/TermCondition";
import ProductionUnit from "../pages/ProductionUnit/ProductionUnit";
import DynamicPage from "../pages/DynamicPage/DynamicPage";
import LandingModular from "../pages/LandingModular/LandingModular";
import EnquiryPopup from "../component/EnquiryPopup";
import { useModal } from "../contexts/ModalContext";

export default function NavRouter({ initialData }) {
  const { modalShow, closeQueryModal } = useModal();

  return (
    <>
      <ScrollToTop />
      <EnquiryPopup show={modalShow} setShow={closeQueryModal} />

      <Routes>
        <Route path="/modular-kitchen-manufacturers-gurgaon" element={<LandingModular />} />

        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home initialData={initialData}/>} />
          <Route path="landing" element={<LandingPage initialData={initialData}/>} />
          <Route path="contact" element={<Contact />} />
          <Route path="blog" element={<Blog initialData={initialData}/>} />
          <Route path="blog/:slug" element={<BlogDetail initialData={initialData}/>} />
          <Route path="about" element={<About />} />
          <Route path="project" element={<ProjectListing initialData={initialData}/>} />
          <Route path="services" element={<Services />} />
          <Route path="bespoke-furniture" element={<ServiceDetail />} />
          <Route path="modular-work" element={<ModularWork />} />
          <Route path="millwork" element={<Millwork />} />
          <Route path="turnkey-solution" element={<TurnkeySolution />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-condition" element={<TermCondition />} />
          <Route path="production-unit" element={<ProductionUnit />} />
          <Route path=":slug" element={<DynamicPage initialData={initialData}/>} />
        </Route>

        {/* Routes without footer*/}
        <Route element={<UserLayout footerHide="footer-hider" />}>
          <Route path="404" element={<Error />} />
          <Route path="*" element={<Navigate to={"/404"} />} />
          <Route path="thankyou" element={<Thankyou />} />
          <Route path="project/:slug" element={<ProjectDetail initialData={initialData}/>} />
        </Route>
      </Routes>
    </>
  )
}
